
export class UserProfileModel {
  userName: string;
  password: string;
  confirmPassword: string;
  isPasswordChanged: true;

  aboutText: string;
  aboutVideoEmbedUrl: string;
  accreditation: string;
  address: string;
  addressLine2: string;
  city: string;
  contactNumber1: string;
  contactNumber1CountryCode: string;
  contactNumber2: string;
  contactNumber2CountryCode: string;
  countryName: string;
  degree: string;
  dicomDeviceId: string;
  email: string;
  enquiryEmailAddress: string;
  facebookUrl: string;
  faxNumber: string;
  faxNumberCountryCode: string;
  firstName: string;
  headerImage: string;
  homeText:string;
  homeVideoEmbedUrl: string;
  image: string;

  instagramHandle: string;
  emailSignature: string;


  licenseNumber: string;
  locationText: string;
  logoImage: string;
  organisation: string;
  displayName: string;
  organisationID: string;
  phoneNumber: string;
  phoneNumberCountryCode: string;
  phoneNumber2: string;
  phoneNumber2CountryCode: string;
  postCode: string;

  stateName: string;
  suffix: string;
  title: string;
  trackingURL: string;
  twitterHandle: string;
  websiteUrl: string;

  isShowOnWebsite: string;
  lastName: string;
  suburb: string;
  smsNumber: string;
  replyToEmailAddress: string;
  hasBusinessProfile: boolean;
  memberTimeZone: string;
  memberId: number;
 
}

export class UploadedProfileImage {
  memberId: number;
  image: string;
}
export class UserTokenInfo {
  memberId: number;
  userId: number;
  tokenExpiryDate: Date;
}
